<a [routerLink]="['/users', userName]">
  {{ userName }}
</a>
